const projects = [
  {
    id: 'hackathon-dedup',
    title: 'Multilingual Duplicate Detection System',
    tagline: '2nd Prize · Innov8 Hackathon (Pixels 2026)',
    period: 'May 2026',
    role: 'Backend & ML Pipeline Lead',
    badge: 'Award Winner',
    badgeType: 'award',
    featured: true,
    category: 'ai',
    access: 'demo',
    accessNote: 'Hackathon build — Streamlit demo shown at event; contact for walkthrough.',
    image: require('../img/hackathon_certs.png'),
    stack: ['Python', 'MiniLM', 'FAISS', 'ONNX', 'Streamlit'],
    highlights: [
      '2nd place among 50+ teams at SIES College — cross-lingual semantic duplicate detection.',
      'MiniLM embeddings + FAISS for fast similarity search; ONNX for ~4.5× CPU inference speedup.',
      'Led backend pipeline and Streamlit productization for real-time data cleaning.',
    ],
    links: {},
  },
  {
    id: 'realtorbazaar',
    title: 'RealtorBazaar',
    tagline: 'Industry Project · Live & Deployed',
    period: 'Mar 2026 – Apr 2026',
    role: 'Full-Stack Developer (Solo)',
    badge: 'Live Project',
    badgeType: 'live',
    featured: true,
    category: 'fullstack',
    access: 'live',
    image: require('../img/realtorbazar.png'),
    imageFit: 'cover',
    stack: ['React.js', 'Node.js', 'Express', 'MongoDB'],
    highlights: [
      'End-to-end real-estate platform built and deployed during MCA — live at realtorbazaar.com.',
      'Property search with category filters (Residential, Commercial, Plot, PG) and admin dashboard.',
      'REST APIs with Node.js/Express, MongoDB, and cloud deployment.',
    ],
    links: { live: 'https://realtorbazaar.com/' },
  },
  {
    id: 'mindguard',
    title: 'MindGuard',
    tagline: 'Academic Project · Android Application',
    period: 'Feb 2026 – Mar 2026',
    role: 'Developer · MCA Project',
    badge: 'MCA Project',
    badgeType: 'mobile',
    featured: true,
    category: 'ai',
    access: 'mobile',
    accessNote:
      'Private Android build — not on Play Store. APK/demo available on request for interviews.',
    image: require('../img/mindguard.png'),
    mediaType: 'mobile',
    stack: ['React Native', 'Firebase', 'Isolation Forest', 'Node.js'],
    highlights: [
      'AI-powered Android app detecting behavioral deviation with on-device anomaly detection.',
      'Privacy-first modules: screen time, app usage, mobility, and nighttime activity patterns.',
      'Isolation Forest risk scoring, CalmBot intervention, guardian alerts, and Firebase workflows.',
    ],
    links: {},
  },
  {
    id: 'mu-inventory',
    title: 'Mumbai University Inventory Management',
    tagline: 'University Project · Examination Department',
    period: 'Dec 2024 – Apr 2025',
    role: 'Full-Stack Developer · Team Project',
    badge: 'University',
    badgeType: 'institutional',
    featured: true,
    category: 'fullstack',
    access: 'internal',
    accessNote:
      'Deployed on university intranet for the examination department — not publicly accessible.',
    image: require('../img/mu-inventory.png'),
    stack: ['React.js', 'Node.js', 'MySQL', 'REST APIs'],
    highlights: [
      'Full-stack inventory & records for Mumbai University examination department operations.',
      'Purchase entries, challans, billing, stock issue, and ledger-based reporting workflows.',
      'Role-based admin, audit logs, vendor/item management, and responsive dashboards.',
    ],
    links: {},
  },
  {
    id: 'studybuddy',
    title: 'StudyBuddy',
    tagline: 'AI-Powered Adaptive Learning Platform',
    period: 'Oct 2025 – Nov 2025',
    role: 'Full-Stack Developer',
    badge: 'Live Demo',
    badgeType: 'live',
    featured: true,
    category: 'ai',
    access: 'live',
    image: require('../img/studybuddy.jpeg'),
    stack: ['React.js', 'Node.js', 'MongoDB', 'Google Gemini'],
    highlights: [
      'Personalised study recommendations and adaptive quizzes from learner performance data.',
      'End-to-end MERN architecture deployed on Render with Gemini API integration.',
      'Dynamic content generation and Gitpath-based quiz personalisation.',
    ],
    links: { live: 'https://studybuddy-kc2m.onrender.com/' },
  },
  {
    id: 'prepa',
    title: 'Prepa – AI Interview Prep',
    tagline: 'AI Interview Practice Application',
    period: '2024',
    role: 'Full-Stack Developer',
    badge: 'AI Product',
    badgeType: 'ai',
    featured: false,
    category: 'ai',
    access: 'live',
    image: require('../img/prepa.jpeg'),
    stack: ['React', 'Python', 'Firebase'],
    highlights: [
      'AI-powered interview practice with real-time feedback and tailored questions.',
      'Deployed production web app with scalable cloud hosting.',
    ],
    links: {
      live: 'https://prepa-d7e15.web.app',
      repo: 'https://github.com/shravanbpatel954/prepa-ai-interview-prep',
    },
  },
  {
    id: 'aio',
    title: 'AIO – AI Advisor',
    tagline: 'Intelligent Advisory Web Application',
    period: '2024',
    role: 'Full-Stack Developer',
    badge: 'Live Demo',
    badgeType: 'live',
    featured: false,
    category: 'ai',
    access: 'live',
    image: require('../img/aio.jpeg'),
    stack: ['React', 'Node.js', 'Express'],
    highlights: [
      'Personalized advice and recommendations via an AI-driven advisor interface.',
      'Full-stack deployment with REST API backend.',
    ],
    links: {
      live: 'https://aio-5igz.onrender.com',
      repo: 'https://github.com/shravanbpatel954/aio-advisor',
    },
  },
  {
    id: 'lakshwear',
    title: 'Lakshwear E-commerce',
    tagline: 'Clothing E-commerce Platform',
    period: '2024',
    role: 'Frontend Developer',
    badge: 'E-commerce',
    badgeType: 'default',
    featured: false,
    category: 'fullstack',
    access: 'live',
    image: require('../img/lakshwear.jpeg'),
    stack: ['React', 'JavaScript', 'CSS3'],
    highlights: [
      'User-friendly shopping experience with secure checkout flows.',
      'Responsive product catalog and account management.',
    ],
    links: {
      live: 'https://lakshwear-full-stack-frontend.onrender.com/',
      repo: 'https://github.com/shravanbpatel954/lakshwear-ecommerce',
    },
  },
  {
    id: 'onlinegamelab',
    title: 'Online Game Lab',
    tagline: 'Interactive Web Games Collection',
    period: '2024',
    role: 'Solo Developer',
    badge: 'Portfolio',
    badgeType: 'default',
    featured: false,
    category: 'fullstack',
    access: 'live',
    image: require('../img/onlinegamelab.jpeg'),
    stack: ['React', 'JavaScript', 'HTML5'],
    highlights: [
      'Collection of browser games exploring game logic and web interactivity.',
      'Deployed on Render with modular game architecture.',
    ],
    links: {
      live: 'https://onlinegamelab.onrender.com/',
      repo: 'https://github.com/shravanbpatel954/online-game-lab',
    },
  },
  {
    id: 'crwa',
    title: 'Creative Recycle Solution',
    tagline: 'Sustainability Web Application',
    period: '2024',
    role: 'Full-Stack Developer',
    badge: 'Live Demo',
    badgeType: 'live',
    featured: false,
    category: 'fullstack',
    access: 'live',
    image: require('../img/crwa.jpeg'),
    stack: ['React', 'JavaScript'],
    highlights: [
      'Guides users to recycle or repurpose everyday items creatively.',
      'Educational UX with actionable sustainability tips.',
    ],
    links: {
      live: 'https://crwa.onrender.com/',
      repo: 'https://github.com/shravanbpatel954/creative-recycle-web',
    },
  },
];

export const ACCESS_LABELS = {
  live: 'Live & publicly accessible',
  internal: 'Internal / institutional deployment',
  mobile: 'Android app — private build',
  demo: 'Event demo — available on request',
};

export const PROJECT_FILTERS = [
  { id: 'all', label: 'All Projects' },
  { id: 'featured', label: 'Featured' },
  { id: 'ai', label: 'AI / ML' },
  { id: 'fullstack', label: 'Full-Stack' },
];

export default projects;
